import { IContractTemplateEditor } from './types';

export const initialState: IContractTemplateEditor = {
  templates: [],
  selectedTemplate: null,
  mergeTokenList: {},
  miscellaneous: {},
};
